import { MicrophoneIcon } from '../../../src/assets/icons/MicrophoneIcon';
import { Card } from '../../components/Card/Card';
import { Text } from '../../components/Text/Text';
import classes from './MicrophoneErrorCard.module.css';

export const MicrophoneErrorCard = (props: { noMicAccess?: boolean }) => {

  return (
    <Card className={classes.root}>
      <MicrophoneIcon id="error-mic-id" className={props.noMicAccess ? classes['micAcess'] : classes['micIcon']} />
      {props.noMicAccess ?
        <>
          <p className={classes['align-center']}>
            <Text text="Microphone access is denied" fontWeight="semibold" variant="heading" />
          </p>
          <p className={classes['align-center']}>
            <Text text="Please allow access to your microphone and refresh the page" variant="body"  />
          </p>
        </>
        :
        <>
          <p className={classes.topRight}>
            <Text text={`V205`} fontWeight="medium" variant="body" />
          </p>
          <p className={classes['align-center']}>
            <Text text="Microphone not found" fontWeight="semibold" variant="heading" />
          </p>
          <p className={classes['align-center']}>
            <Text text="Please connect your headset" variant="body" />
          </p>
        </>
      }
    </Card>
  );
};
